module.exports = __webpack_public_path__ + "static/video-man-v-food-bfb0c26d987f48c678b4074d84b9636a.mp4";